export const INCIDENT_STATUS = {
  OPENED: "Opened",
  IN_PROCCESS: "InProccess",
  RESOLVED: "Resolved",
};
